import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateCargoOrder as updateCargoOrderAction } from 'actions/cargoes/orders';
import Bulk from './Bulk';
import Unpacked from './Unpacked';
import Packed from './Packed';
import Loose from './Loose';
import { getPackingForBreakBulk, getPackingTransportation } from './common';
import _ from 'lodash';
import WetBulk from './WetBulk';
import Container from './Container';


const allCategories = [
    'bulk', 'unpacked', 'packed', 'loose', 'wetBulk', 'container',
];

function Packing({ 
    numberOrderTable, cargoPackingIndex, cargoOrder, updateCargoOrder,
}) {
    const [currentEnabled, setCurrentEnabled] = useState(allCategories);

    useEffect(() => {
        const fields = getPackingTransportation(cargoOrder.cargo[cargoPackingIndex].cargoTypeName);
        const { typeOfTransportation, details } = cargoOrder.cargo[cargoPackingIndex];

        let availablePacked = fields[typeOfTransportation];

        let resetTransportation;
        let resetPacking;

        if (!availablePacked) {
            resetTransportation = Object.keys(fields)[0];
            resetPacking = Object.values(fields)[0];
        }

        if (typeOfTransportation === 'breakbulk' || resetTransportation === 'breakbulk') {
            availablePacked = getPackingForBreakBulk(details);
        }

        setCurrentEnabled(availablePacked || resetPacking);

        const newCargoOrder = _.cloneDeep(cargoOrder);
        if (availablePacked && !resetTransportation) {
            _.set(newCargoOrder.cargo[cargoPackingIndex].packing, 'category', availablePacked[0]);
        } else {
            _.set(newCargoOrder.cargo[cargoPackingIndex].packing, 'category', resetPacking[0]);
            _.set(newCargoOrder.cargo[cargoPackingIndex], 'typeOfTransportation', resetTransportation);
        }
        updateCargoOrder(numberOrderTable, newCargoOrder);
    }, [
        cargoOrder.cargo[cargoPackingIndex].typeOfTransportation,
        cargoOrder.cargo[cargoPackingIndex].cargoType,
    ]);

    return (
        <React.Fragment>
            <span style={{ fontSize: '16px', lineHeight: '22px' }}>PACKING*</span>
            <Bulk 
                numberOrderTable={numberOrderTable}
                cargoPackingIndex={cargoPackingIndex}
                canCheck={currentEnabled.includes('bulk')}
            />
            <Unpacked 
                numberOrderTable={numberOrderTable}
                cargoPackingIndex={cargoPackingIndex}
                canCheck={currentEnabled.includes('unpacked')}
            />
            <Packed 
                numberOrderTable={numberOrderTable}
                cargoPackingIndex={cargoPackingIndex}
                canCheck={currentEnabled.includes('packed')}
            />
            <Loose 
                numberOrderTable={numberOrderTable}
                cargoPackingIndex={cargoPackingIndex}
                canCheck={currentEnabled.includes('loose')}
            />
            <WetBulk 
                numberOrderTable={numberOrderTable}
                cargoPackingIndex={cargoPackingIndex}
                canCheck={currentEnabled.includes('wetBulk')}
            />
            <Container 
                numberOrderTable={numberOrderTable}
                cargoPackingIndex={cargoPackingIndex}
                canCheck={
                    currentEnabled.includes('container')
                }
            />
        </React.Fragment>
    );
}

export default React.memo(connect(
    (state, ownProps) => 
        ({
            cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
        })
    ,
    dispatch => bindActionCreators({
        updateCargoOrder: updateCargoOrderAction,
    }, dispatch),
)(Packing));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Packing.jsx